export default {
  default: () => import("/codebuild/output/src2504466115/src/src/layouts/default.vue").then(m => m.default || m)
}